<template>
  <div class="container">
    <!--banner-->
    <div class="nban pc">
      <img src="@/view/images/y73.jpg" />
      <div class="nbana nbana_gy">
        <p class="on">
          <a href="javascript:void(0);" @click="goAnchor('gy')">公司介绍</a>
        </p>
        <p>
          <a href="javascript:void(0);" @click="goAnchor('gy1')">企业文化</a>
        </p>
        <p>
          <a href="javascript:void(0);" @click="goAnchor('gy2')">专家团队</a>
        </p>
        <p>
          <a href="javascript:void(0);" @click="goAnchor('gy3')">战略布局</a>
        </p>
        <p>
          <a href="javascript:void(0);" @click="goAnchor('gy4')">联系我们</a>
        </p>
        <div class="clearfix"></div>
      </div>
    </div>
    <!-- <div class="mbx pc">
      <div class="commen">
        <p>位置：<a href="#">首页</a> &gt; <a href="#">关于我们</a></p>
      </div>
    </div> -->
    <!--关于我们页-->
    <div class="neiy">
      <div class="commen">
        <!-- <div class="nbana nbana_gy mob">
          <p class="on"><a href="javascript:void(0);" @click="goAnchor('gy')">公司介绍</a></p>
          <p><a href="javascript:void(0);" @click="goAnchor('gy1')">企业文化</a></p>
          <p><a href="javascript:void(0);" @click="goAnchor('gy2')">专家团队</a></p>
          <p><a href="javascript:void(0);" @click="goAnchor('gy3')">战略布局</a></p>
          <p><a href="javascript:void(0);" @click="goAnchor('gy4')">联系我们</a></p>
          <div class="clearfix"></div>
        </div> -->
        <div class="gyya">
          <div class="bt reveal-aboutop" id="gy">
            <h6>公司介绍</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="gyyaa">
            <img class=" reveal-aboutop" src="@/view/images/y76.png" />
            <p class=" reveal-aboutop">
              印工社是一家以“打造印刷工业联网平台新生态，建设印刷产业云赋能、印刷企业数增效、印刷产品智增值的新模式，助推传统印刷企业转型升级、绿色发展和共享共赢的新发展”为愿景，研发与集成印刷链核心软硬件，为印刷企业提供低成本的数字化、智能化解决方案的技术型企业。
            </p>
          </div>
          <div class="gyyab">
            <div class="gyyab_a fl reveal-aboutop">
              <h6>印刷行业经验<br />业内资深专家</h6>
              <p>
                觉机器人专家<br />印刷系统应用专家<br />色彩管理专家<br />......
              </p>
            </div>
            <div class="gyyab_a fl reveal-aboutop">
              <h6>智能研究院<br />科研基地等</h6>
              <p>
                印工社有智能研究院<br />科研成果实训基地<br />全国高校产学研中心<br />......
              </p>
            </div>
            <div class="gyyab_a fl reveal-aboutop">
              <h6>打造印刷工业互联网<br />服务平台</h6>
              <p>
                打造印刷工业互联网服务平台<br />助力印刷企业实现印前数字化全流程管理体系<br />和智能化工厂的升级<br />......
              </p>
            </div>
            <div class="gyyab_a fl reveal-aboutop">
              <h6>印刷技术和管理等<br />专业课程提供</h6>
              <p>
                提供印刷技术和管理等方面的专业课程<br />帮助印刷企业稳步实现数字化、智能化<br />......
              </p>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="bt reveal-aboutop" id="gy1">
            <h6>企业文化</h6>
            <img src="@/view/images/y8.png" />
          </div>
        </div>
      </div>
      <div class="gyyb">
        <div class="gyyba fl">
          <h5>愿景</h5>
          <p>打造印刷行业工业互联网平台</p>
          <span></span>
          <h6>vision</h6>
        </div>
        <div class="gyyba fl">
          <h5>使命</h5>
          <p>引领印数行业共同步入数字化智能化</p>
          <span></span>
          <h6>mission</h6>
        </div>
        <div class="gyyba fl">
          <h5>价值观</h5>
          <p>共建 共享 共赢</p>
          <span></span>
          <h6>values</h6>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="gyyc" id="gy2">
        <div class="commen">
          <div class="bt reveal-aboutop">
            <h6>专家团队</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="gyyca">
            <div class="gyycaa reveal-aboutop">
              <div class="xllbc_t fl"><img src="@/view/images/y58.jpg" /></div>
              <div class="xllbc_w fr">
                <h5>王强<span>wang qiang</span></h5>
                <h6>色彩管理专家，印刷专家、二级教授、博导</h6>
                <div class="xllbc_wx">
                  <div class="xllbc_wa">
                    <span>荣誉 |</span>
                    <p>
                      <br />⊙杭州电子科技大学特聘教授、武汉大学教授、天津科技大学客座教授、北京印刷学院兼职教授，上海理工大学兼职教授、南京林业大学、大连工业大学兼职教授
                      <br />⊙中国印刷科学技术研究院特聘研究员、国际ISO
                      TC130注册专家、国际G7认证专家、国家科学技术奖评审专家
                      <br />⊙中国环境科学学会绿色包装委员会副理事长、中国印刷技术协会常务理事、中国数字印刷协会副会长
                      <br />⊙中国印刷工业与器材协会专家、亚洲印刷大奖赛独立评审专家、中华印制大奖赛评审专家、金光印艺大奖赛资深评审专家
                      <br />⊙《中国印刷与包装研究》/《数码印刷》/《印刷杂志》编委
                      <br />⊙2011获“亚洲印刷终身成就奖”，2017年获“中华印刷杰出人物奖”。
                    </p>
                    <div class="clearfix"></div>
                  </div>
                  <br />
                  <div class="xllbc_wa">
                    <span>介绍 |</span>
                    <p>
                      从事印刷教育与科研36年，指导博士、硕士研究生120余人，公开出版《分色原理与方法》、《印刷媒体技术手册》等17部著作，发表论文150余篇，承担了国家科技支撑计划等30余项国家和省部级科研项目，获得20项国家发明专利。
                    </p>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="xllbc_wxa">
                  <div class="xllbc_wa">
                    <span>荣誉 |</span>
                    <p>
                      <br />⊙杭州电子科技大学特聘教授、武汉大学教授、天津科技大学客座教授、北京印刷学院兼职教授，上海理工大学兼职教授、南京林业大学、大连工业大学兼职教授
                      <br />⊙中国印刷科学技术研究院特聘研究员、国际ISO
                      TC130注册专家、国际G7认证专家、国家科学技术奖评审专家
                      <br />⊙中国环境科学学会绿色包装委员会副理事长、中国印刷技术协会常务理事、中国数字印刷协会副会长
                      <br />⊙中国印刷工业与器材协会专家、亚洲印刷大奖赛独立评审专家、中华印制大奖赛评审专家、金光印艺大奖赛资深评审专家
                      <br />⊙《中国印刷与包装研究》/《数码印刷》/《印刷杂志》编委
                      <br />⊙2011获“亚洲印刷终身成就奖”，2017年获“中华印刷杰出人物奖”。
                    </p>
                    <div class="clearfix"></div>
                  </div>
                  <br />
                  <div class="xllbc_wa">
                    <span>介绍 |</span>
                    <p>
                      从事印刷教育与科研36年，指导博士、硕士研究生120余人，公开出版《分色原理与方法》、《印刷媒体技术手册》等17部著作，发表论文150余篇，承担了国家科技支撑计划等30余项国家和省部级科研项目，获得20项国家发明专利。
                    </p>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <h3>下拉查看更多</h3>
              </div>
              <div class="clearfix"></div>
              <div class="xllbc_k">色彩管理专家</div>
            </div>
            <div class="gyycaa reveal-aboutop">
              <div class="xllbc_t fl"><img src="@/view/images/y60.jpg" /></div>
              <div class="xllbc_w fr">
                <h5>孙智峰<span>sun zhi feng</span></h5>
                <h6>南京大学博导+精益生产专家+流程再造专家</h6>
                <div class="xllbc_wx">
                  <div class="xllbc_wa">
                    <span>荣誉 |</span>
                    <p>
                      ⊙全球智能制造产业联盟成员<br />⊙南京大学博导+精益生产专家+流程再造专家，生产智能制造专家
                    </p>
                    <div class="clearfix"></div>
                  </div>
                  <br />
                  <div class="xllbc_wa">
                    <span>介绍 |</span>
                    <p>
                      擅长制造行业企业运作，物流领域商务智能，系统建模，建构设计，需求分析，流程再造
                      <br />曾获南京大学优秀教师鹰松奖
                      <br />中国高新技术博览会银奖、第八届中国北京国际科技产业博览会优秀发明人
                      <br />中国南京全国高新技术博览会银奖（1995）
                      <br />淮安市科学技术进步三等奖（1996）
                      <br />第八届中国北京国际科技产业博览会优秀发明人（2005）。
                    </p>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="xllbc_wxa">
                  <div class="xllbc_wa">
                    <span>荣誉 |</span>
                    <p>
                      ⊙全球智能制造产业联盟成员<br />⊙南京大学博导+精益生产专家+流程再造专家，生产智能制造专家
                    </p>
                    <div class="clearfix"></div>
                  </div>
                  <br />
                  <div class="xllbc_wa">
                    <span>介绍 |</span>
                    <p>
                      擅长制造行业企业运作，物流领域商务智能，系统建模，建构设计，需求分析，流程再造
                      <br />曾获南京大学优秀教师鹰松奖
                      <br />中国高新技术博览会银奖、第八届中国北京国际科技产业博览会优秀发明人
                      <br />中国南京全国高新技术博览会银奖（1995）
                      <br />淮安市科学技术进步三等奖（1996）
                      <br />第八届中国北京国际科技产业博览会优秀发明人（2005）。
                    </p>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <h3>下拉查看更多</h3>
              </div>
              <div class="clearfix"></div>
              <div class="xllbc_k">智能制造专家</div>
            </div>

            <div class="gyycaa reveal-aboutop">
              <div class="xllbc_t fl"><img src="@/view/images/y59.jpg" /></div>
              <div class="xllbc_w fr">
                <h5>薛世儒<span>xue shi ru</span></h5>
                <h6>40余年行业经验+英国伦敦大学硕士+印刷系统应用专家</h6>
                <div class="xllbc_wx">
                  <div class="xllbc_wa">
                    <span>荣誉 |</span>
                    <p>
                      ⊙印刷系统应用专家
                      <br />⊙国际软件专家，香港金豪系统创世人
                      <br />⊙英国伦敦大学计算机工程硕士，英国Watford印刷工业学院学士
                      <br />⊙英国、美国、香港印刷商会会员，香港职业训练局委员，香港印艺学会永远资深顾问
                    </p>
                    <div class="clearfix"></div>
                  </div>
                  <br />
                  <div class="xllbc_wa">
                    <span>介绍 |</span>
                    <p>
                      服务全球印刷行业40余年，专注于行业痛点的解决方案及先进技术工具的推广和分享。
                    </p>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="xllbc_wxa">
                  <div class="xllbc_wa">
                    <span>荣誉 |</span>
                    <p>
                      ⊙薛世儒先生，印刷系统应用专家
                      <br />⊙国际软件专家，香港金豪系统创世人
                      <br />⊙英国倫敦大学計算机工程硕士+全球资深顾问，英国Watford印刷工业学院学士
                      <br />⊙英国，美国
                      ，香港印刷商会会员，香港職业训練局委员，香港印艺学会永远资深顾问
                    </p>
                    <div class="clearfix"></div>
                  </div>
                  <br />
                  <div class="xllbc_wa">
                    <span>介绍 |</span>
                    <p>
                      服务全球印刷行业40余年，专注于行业痛点的解决方案及先进技术工具的推广和分享。
                    </p>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <h3>下拉查看更多</h3>
              </div>
              <div class="clearfix"></div>
              <div class="xllbc_k">应用系统专家</div>
            </div>
            <div class="gyycaa reveal-aboutop">
              <div class="xllbc_t fl"><img src="@/view/images/y57.jpg" /></div>
              <div class="xllbc_w fr">
                <h5>陈&emsp;珉<span>Min CHEN</span></h5>
                <h6>海归专业人才+垂直领域专家</h6>
                <div class="xllbc_wx">
                  <div class="xllbc_wa">
                    <span>荣誉 |</span>
                    <p>
                      ⊙觉机器人专家<br />⊙英国诺丁汉大学计算机图形处理博士<br />⊙中国光电博览会高峰论坛（CIOE）专家委员会委员
                    </p>
                    <div class="clearfix"></div>
                  </div>
                  <br />
                  <div class="xllbc_wa">
                    <span>介绍 |</span>
                    <p>
                      自主研发视觉系统深度学习机器人，擅长视觉传感器与智能识别，算法领域的研发，掌握多项国家专利核心技术
                    </p>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <div class="xllbc_wxa">
                  <div class="xllbc_wa">
                    <span>荣誉 |</span>
                    <p>
                      ⊙觉机器人专家<br />⊙英国诺丁汉大学计算机图形处理博士<br />⊙中国光电博览会高峰论坛（CIOE）专家委员会委员
                    </p>
                    <div class="clearfix"></div>
                  </div>
                  <br />
                  <div class="xllbc_wa">
                    <span>介绍 |</span>
                    <p>
                      自主研发视觉系统深度学习机器人，擅长视觉传感器与智能识别，算法领域的研发，掌握多项国家专利核心技术
                    </p>
                    <div class="clearfix"></div>
                  </div>
                </div>
                <h3>下拉查看更多</h3>
              </div>
              <div class="clearfix"></div>
              <div class="xllbc_k">视觉机器人专家</div>
            </div>
          </div>
        </div>
      </div>
      <div class="gyyd" id="gy3">
        <div class="commen">
          <div
            class="gyyda fl"
            data-scroll-reveal="enter left and move 30px over 0.3s"
          >
            <div class="gyyda_a">
              <h6>战略布局</h6>
              <img src="@/view/images/y32.png" />
              <p>Printer Cybertech<br />Strategic Layout</p>
            </div>
            <div class="gyyda_b">
              <p>青岛-总部研发中心</p>
              <p>上海-华东运营中心</p>
              <p>广州-华南运营中心</p>
              <p>西安-西北运营中心</p>
              <p>天津-京津冀运营中心</p>
              <p>成都-西南运营中心</p>
            </div>
          </div>
          <div class="gyydb fr reveal-aboutop">
            <img src="@/view/images/y77.png" />
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <div class="gyye" id="gy4">
        <div class="commen1">
          <div class="bt reveal-aboutop">
            <h6>联系我们</h6>
            <img src="@/view/images/y8.png" />
          </div>
          <div class="gyyea">
            <div class="gyyeb fl reveal-aboutop">
              <div class="gyyeb_a fl">
                <img src="@/view/images/y79.png" />
                <p><span>总部地址</span>青岛市高新区祥源路831号青岛报业传媒数字印刷产业园综合楼3楼</p>
                <div class="clearfix"></div>
              </div>
              <div class="gyyeb_a fl">
                <img src="@/view/images/y80.png" />
                <p><span>公司官网</span>www.cpct.net.cn</p>
                <div class="clearfix"></div>
              </div>
              <div class="gyyeb_a fl">
                <img src="@/view/images/y81.png" />
                <p><span>联系方式</span>400-999-2025</p>
                <div class="clearfix"></div>
              </div>
              <div class="gyyeb_a fl">
                <img src="@/view/images/y82.png" />
                <p><span>邮箱</span>ygs@cpct.net.cn</p>
                <div class="clearfix"></div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="gyyec fr reveal-aboutop">
              <div class="gyyeca fl">
                <img src="@/view/images/ewm.png" />
                <p>印刷管家APP <br />扫码下载</p>
              </div>
              <div class="gyyeca fl">
                <img src="@/view/images/ewm1.png" />
                <p>印工社公众号 <br />扫码关注</p>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="ditu reveal-aboutop">
            <div class="pc">
              <baidu-map
                :center="{ lng: 120.41037070782674, lat: 36.2944084054551 }"
                id="dituContent"
                @ready="handler"
                :zoom="17"
                style="height:270px"
                ak="rQxHPQX1ua21rWnXzTbUh5KSSUbnefxR"
              >
                <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
              </baidu-map>

              <!--<iframe frameborder="0" scrolling="no" style="width:100%;height:270px;" src="../../public/html/map1.html"></iframe>-->
            </div>
            <div class="mob">
              <baidu-map
                :center="{ lng: 120.29833, lat: 36.261445 }"
                @ready="handler"
                :zoom="17"
                style="width:100%;height:270px"
                ak="rQxHPQX1ua21rWnXzTbUh5KSSUbnefxR"
              >
                <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
              </baidu-map>
              <!--<iframe frameborder="0" scrolling="no" style="width:100%;height:220px;" src="../../public/html/map2.html"></iframe>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?0fb0c350f1482064e25902f9db8dec76";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
</script>
<script>
import $ from 'jquery'; // 在需要使用的页面中
import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
import BmScale from 'vue-baidu-map/components/controls/Scale'; // 比例尺组件
import BmNavigation from 'vue-baidu-map/components/controls/Navigation'; //　缩放组件
import BmMarker from 'vue-baidu-map/components/overlays/Marker'; // 标记点的组件
import BmLabel from 'vue-baidu-map/components/overlays/Label'; // 标签组件，展示在标记点中的数字
import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow'; // 信息窗体

export default {
  name: 'aboutName',
  components: {
    BaiduMap,
    BmScale,
    BmNavigation,
    BmMarker,
    BmLabel,
    BmInfoWindow,
  },
  data() {
    return {};
  },
  methods: {
    init() {
      $(() => {
        $('.xllbc_wxa').hide();
        $('.gyycaa h3').click(function () {
          if (
            $(this)
              .siblings('.xllbc_wxa')
              .css('display') === 'none'
          ) {
            $(this)
              .siblings('.xllbc_wx')
              .hide();
            $(this)
              .siblings('.xllbc_wxa')
              .slideDown();
            $(this).html('收起');
          } else {
            $(this)
              .siblings('.xllbc_wxa')
              .hide();
            $(this)
              .siblings('.xllbc_wx')
              .slideDown();
            $(this).html('下拉查看更多');
          }
        });
      });
    },

    goAnchor(type) {
      const _this = this;
      const anchor = _this.$el.querySelector(`#${type}`);
      // chrome
      document.body.scrollTop = anchor.offsetTop;
      // firefox
      document.documentElement.scrollTop = anchor.offsetTop;
    },
    handler() {

    },
  },
  mounted() {},
  created() {
    this.init();
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/view/about.vue